export const mail = {
  en: {
    templateValuesTitle: "Fill in this template",
    templateValuesHint: "The template asks for these. Values taken from the recipient are filled in already; the rest are yours to write. The text is inserted once they are all present.",
    templateInsert: "Insert",
    templateCancel: "Choose another",
    templateDerived: "from the recipient",
    attachFile: "Attach a file",
    attachFileHint: "PDF, PNG, JPEG, Word or Excel, up to 10 MB each. Word and Excel cannot be previewed in the browser — the recipient downloads them.",
    attachRemove: "Remove",
    attachTooLarge: "That file is larger than 10 MB.",
    attachUnsupported: "Only PDF, PNG, JPEG, Word and Excel files can be attached.",
    attachUnreadable: "That file could not be read. Please choose it again.",
    attachDownload: "Download",
    deleteTemplateTitle: "Delete this template?",
    deleteTemplateBody: "Messages already sent are unaffected. System templates cannot be deleted.",
    deleteAccountTitle: "Delete this mail account?",
    deleteAccountBody: "Outgoing email will stop working if this is the only active account.",
    deleteSignatureTitle: "Delete this signature?",
    deleteSignatureBody: "Messages already sent are not affected.",
    deleteFilterTitle: "Delete this filter?",
    deleteFilterBody: "Incoming messages will no longer be sorted by this rule.",
    cancelSendTitle: "Cancel this send?",
    cancelSendBody: "The message will not be delivered to its recipients.",
    title: "Mail Center",
    compose: "Compose",
    inbox: "Inbox",
    drafts: "Drafts",
    outbox: "Outbox",
    sent: "Sent",
    failed: "Failed",
    trash: "Trash",
    starred: "Starred",
    labels: "Labels",
    templates: "Templates",
    signatures: "Signatures",
    accounts: "Mail accounts",
    filters: "Filters",
    settings: "Mail settings",
    searchPlaceholder: "Search subject and message text",
    noMessages: "Nothing here.",
    selectMessage: "Select a message to read it.",
    to: "To",
    cc: "Cc",
    bcc: "Bcc",
    subject: "Subject",
    message: "Message",
    send: "Send",
    saveDraft: "Save draft",
    schedule: "Schedule",
    scheduledFor: "Scheduled for {date}",
    reply: "Reply",
    forward: "Forward",
    cancelSend: "Cancel",
    retry: "Retry",
    markRead: "Mark as read",
    markUnread: "Mark as unread",
    star: "Star",
    unstar: "Remove star",
    moveToTrash: "Move to trash",
    restore: "Restore",
    attachments: "Attachments",
    attachDocument: "Attach a document",
    channel: "Channel",
    channelInApp: "In-app",
    channelEmail: "Email",
    stateDraft: "Draft",
    stateScheduled: "Scheduled",
    stateQueued: "Queued",
    stateSending: "Sending",
    stateSent: "Sent",
    stateFailed: "Failed",
    stateCancelled: "Cancelled",
    stateReceived: "Received",
    deliveryStatus: "Delivery",
    deliveredTo: "Delivered to {count}",
    failedFor: "{count} could not be reached",
    permanentFailure: "This address was rejected. Correct it and send again rather than retrying.",
    history: "Delivery history",
    template: "Template",
    templateStepTitle: "Start from a template",
    templateStepNote: "Add the person first, then choose a template — the wording fills in their name and details from the recipient. Writing the message by hand is fine, but check here first: there may already be one for this.",
    templateStepNone: "Write it myself",
    templateNeedsRecipient: "Add the member of staff to the recipients first, then choose the template again. The wording asks for their name, and there is nobody to read it from yet.",
    accountTemplateTitle: "This message carries a password",
    accountTemplateReissues: "A temporary password cannot be recovered — it is stored one-way and even this system cannot read it back. Sending these details now therefore issues a NEW temporary password. The old one stops working immediately, any open session on the account ends, and they will be asked to choose their own the next time they sign in.",
    accountTemplateUsername: "Username",
    accountTemplateSend: "Issue a new password and send",
    accountTemplateNoAccount: "This person has no login account, so there are no sign-in details to send. Create one from their contract.",
    openTask: "Open the task",
    openLeaveRequest: "Open the leave request",
    openRequest: "Open the request",
    openPayrollRun: "Open the payroll run",
    openDocument: "Open the document",
    templateName: "Template name",
    templateNameEn: "Template name (English)",
    templateNameAr: "Template name (Arabic)",
    templateCode: "Code",
    templateVariables: "Variables",
    preview: "Preview",
    subjectEn: "Subject (English)",
    subjectAr: "Subject (Arabic)",
    bodyEn: "Message (English)",
    bodyAr: "Message (Arabic)",
    systemTemplate: "System template",
    signatureName: "Signature name",
    defaultSignature: "Use by default",
    smtpHost: "Server",
    smtpPort: "Port",
    smtpEncryption: "Encryption",
    smtpUsername: "Username",
    smtpPassword: "Password",
    passwordUnchanged: "Leave blank to keep the stored password",
    fromAddress: "From address",
    fromName: "From name",
    replyTo: "Reply-to address",
    isDefault: "Default for this channel",
    testConnection: "Test connection",
    testPassed: "Connected successfully",
    testFailed: "Connection failed",
    neverTested: "Never tested",
    lastTested: "Last tested {date}",
    receiving: "Receiving (IMAP)",
    imapHost: "Incoming server",
    imapPort: "Port",
    imapEncryption: "Encryption",
    imapUsername: "Username",
    imapPassword: "Password",
    imapMailbox: "Folder",
    imapEnabled: "Read this mailbox into the Inbox",
    imapHint: "Sending and receiving are separate servers. Gmail sends through smtp.gmail.com:587 and is read at imap.gmail.com:993, with an app password.",
    testInbox: "Test mailbox",
    checkInbox: "Check now",
    inboxOwners: "Arriving mail goes to everyone who may read any mailbox — the system administrator and HR.",
    neverPolled: "Never read",
    lastPolled: "Last read {date}",
    channelAll: "Everything",
    noEmailYet: "No email here yet. Mail arrives once a mailbox is configured and switched on in Mail settings.",
    filterName: "Filter name",
    filterWhen: "When",
    filterThen: "Then",
    addCondition: "Add condition",
    notifications: "Notifications",
    noNotifications: "Nothing new.",
    viewAll: "Open Mail Center",
    unreadCount: "{count} unread",
  },
  ar: {
    templateValuesTitle: "عبّئ هذا القالب",
    templateValuesHint: "يطلب القالب هذه القيم. ما يمكن اشتقاقه من المستلم معبّأ مسبقاً، والبقية عليك. يُدرج النص بعد اكتمالها جميعاً.",
    templateInsert: "إدراج",
    templateCancel: "اختر قالباً آخر",
    templateDerived: "من المستلم",
    attachFile: "إرفاق ملف",
    attachFileHint: "ملفات PDF أو PNG أو JPEG أو ورد أو إكسل، حتى 10 ميجابايت لكل ملف. ملفات ورد وإكسل لا يمكن عرضها في المتصفح — يقوم المستلم بتنزيلها.",
    attachRemove: "إزالة",
    attachTooLarge: "حجم الملف أكبر من 10 ميجابايت.",
    attachUnsupported: "يمكن إرفاق ملفات PDF و PNG و JPEG وورد وإكسل فقط.",
    attachUnreadable: "تعذر قراءة هذا الملف. يرجى اختياره مرة أخرى.",
    attachDownload: "تنزيل",
    deleteTemplateTitle: "حذف هذا القالب؟",
    deleteTemplateBody: "لن تتأثر الرسائل المرسلة سابقاً. لا يمكن حذف قوالب النظام.",
    deleteAccountTitle: "حذف حساب البريد هذا؟",
    deleteAccountBody: "سيتوقف إرسال البريد إذا كان هذا هو الحساب الفعّال الوحيد.",
    deleteSignatureTitle: "حذف هذا التوقيع؟",
    deleteSignatureBody: "لن يؤثر ذلك على الرسائل المرسلة سابقاً.",
    deleteFilterTitle: "حذف هذا الفلتر؟",
    deleteFilterBody: "لن يتم تطبيق هذا الفلتر على الرسائل الواردة بعد الآن.",
    cancelSendTitle: "إلغاء الإرسال؟",
    cancelSendBody: "لن يتم إرسال هذه الرسالة إلى مستلميها.",
    title: "مركز المراسلات",
    compose: "رسالة جديدة",
    inbox: "الوارد",
    drafts: "المسودات",
    outbox: "الصادر",
    sent: "المُرسل",
    failed: "فشل الإرسال",
    trash: "المحذوفات",
    starred: "المميزة",
    labels: "التصنيفات",
    templates: "القوالب",
    signatures: "التواقيع",
    accounts: "حسابات البريد",
    filters: "الفلاتر",
    settings: "إعدادات البريد",
    searchPlaceholder: "ابحث في الموضوع ونص الرسالة",
    noMessages: "لا توجد رسائل.",
    selectMessage: "اختر رسالة لعرضها.",
    to: "إلى",
    cc: "نسخة",
    bcc: "نسخة مخفية",
    subject: "الموضوع",
    message: "الرسالة",
    send: "إرسال",
    saveDraft: "حفظ كمسودة",
    schedule: "جدولة",
    scheduledFor: "مجدولة في {date}",
    reply: "رد",
    forward: "إعادة توجيه",
    cancelSend: "إلغاء",
    retry: "إعادة المحاولة",
    markRead: "تعليم كمقروءة",
    markUnread: "تعليم كغير مقروءة",
    star: "تمييز",
    unstar: "إزالة التمييز",
    moveToTrash: "نقل إلى المحذوفات",
    restore: "استعادة",
    attachments: "المرفقات",
    attachDocument: "إرفاق مستند",
    channel: "القناة",
    channelInApp: "داخل النظام",
    channelEmail: "بريد إلكتروني",
    stateDraft: "مسودة",
    stateScheduled: "مجدولة",
    stateQueued: "في الانتظار",
    stateSending: "جارٍ الإرسال",
    stateSent: "تم الإرسال",
    stateFailed: "فشل",
    stateCancelled: "ملغاة",
    stateReceived: "واردة",
    deliveryStatus: "حالة التسليم",
    deliveredTo: "تم التسليم إلى {count}",
    failedFor: "تعذر الوصول إلى {count}",
    permanentFailure: "تم رفض هذا العنوان. صححه وأعد الإرسال بدلاً من إعادة المحاولة.",
    history: "سجل الإرسال",
    template: "القالب",
    templateStepTitle: "ابدأ من قالب",
    templateStepNote: "أضف الشخص أولاً ثم اختر القالب — تُعبَّأ الصياغة باسمه وبياناته من المستلم. كتابة الرسالة يدوياً ممكنة، لكن تحقّق هنا أولاً: قد يكون هناك قالب جاهز لهذه الحالة.",
    templateStepNone: "سأكتبها بنفسي",
    templateNeedsRecipient: "أضف الموظف إلى المستلمين أولاً ثم اختر القالب مرة أخرى. الصياغة تطلب اسمه ولا يوجد من تُقرأ بياناته بعد.",
    accountTemplateTitle: "هذه الرسالة تحمل كلمة مرور",
    accountTemplateReissues: "لا يمكن استرجاع كلمة المرور المؤقتة — فهي مخزّنة بتشفير غير قابل للعكس ولا يستطيع النظام نفسه قراءتها. لذا فإن إرسال هذه البيانات الآن يُصدر كلمة مرور مؤقتة جديدة. تتوقف القديمة عن العمل فوراً، وتنتهي أي جلسة مفتوحة على الحساب، وسيُطلب منه اختيار كلمة مرور خاصة به عند تسجيل الدخول التالي.",
    accountTemplateUsername: "اسم المستخدم",
    accountTemplateSend: "إصدار كلمة مرور جديدة وإرسالها",
    accountTemplateNoAccount: "لا يوجد حساب دخول لهذا الشخص، لذا لا توجد بيانات دخول لإرسالها. أنشئ حساباً من عقده.",
    openTask: "فتح المهمة",
    openLeaveRequest: "فتح طلب الإجازة",
    openRequest: "فتح الطلب",
    openPayrollRun: "فتح مسير الرواتب",
    openDocument: "فتح المستند",
    templateName: "اسم القالب",
    templateNameEn: "اسم القالب (بالإنجليزية)",
    templateNameAr: "اسم القالب (بالعربية)",
    templateCode: "الرمز",
    templateVariables: "المتغيرات",
    preview: "معاينة",
    subjectEn: "الموضوع (إنجليزي)",
    subjectAr: "الموضوع (عربي)",
    bodyEn: "النص (إنجليزي)",
    bodyAr: "النص (عربي)",
    systemTemplate: "قالب نظامي",
    signatureName: "اسم التوقيع",
    defaultSignature: "استخدامه افتراضياً",
    smtpHost: "الخادم",
    smtpPort: "المنفذ",
    smtpEncryption: "التشفير",
    smtpUsername: "اسم المستخدم",
    smtpPassword: "كلمة المرور",
    passwordUnchanged: "اتركه فارغاً للإبقاء على كلمة المرور المحفوظة",
    fromAddress: "عنوان المُرسل",
    fromName: "اسم المُرسل",
    replyTo: "عنوان الرد",
    isDefault: "الافتراضي لهذه القناة",
    testConnection: "اختبار الاتصال",
    testPassed: "تم الاتصال بنجاح",
    testFailed: "فشل الاتصال",
    neverTested: "لم يُختبر",
    lastTested: "آخر اختبار {date}",
    receiving: "الاستقبال (IMAP)",
    imapHost: "خادم الوارد",
    imapPort: "المنفذ",
    imapEncryption: "التشفير",
    imapUsername: "اسم المستخدم",
    imapPassword: "كلمة المرور",
    imapMailbox: "المجلد",
    imapEnabled: "اقرأ هذا الصندوق إلى الوارد",
    imapHint: "الإرسال والاستقبال خادمان مختلفان. جيميل يُرسل عبر smtp.gmail.com:587 ويُقرأ من imap.gmail.com:993 بكلمة مرور تطبيق.",
    testInbox: "اختبار الصندوق",
    checkInbox: "اقرأ الآن",
    inboxOwners: "البريد الوارد يصل كل من يملك قراءة أي صندوق — مدير النظام والموارد البشرية.",
    neverPolled: "لم يُقرأ",
    lastPolled: "آخر قراءة {date}",
    channelAll: "الكل",
    noEmailYet: "لا يوجد بريد هنا بعد. البريد يصل بعد ضبط صندوق في إعدادات البريد وتفعيل قراءته.",
    filterName: "اسم الفلتر",
    filterWhen: "عندما",
    filterThen: "قم بـ",
    addCondition: "إضافة شرط",
    notifications: "الإشعارات",
    noNotifications: "لا يوجد جديد.",
    viewAll: "فتح مركز المراسلات",
    unreadCount: "{count} غير مقروءة",
  },
} as const;
